import { ReactElement } from 'react'
import {
  GetStaticPropsContext,
  InferGetStaticPropsType,
  NextPageContext
} from 'next'

import Meta from '@/components/base/Meta'
import Layout from '@/components/layout/Layout'
import PageBuilder from '@/components/pages/PageBuilder'
import usePagePrecache from '@/hooks/usePagePrecache'
import { getPagePrecacheMedia } from '@/utils/page'
import { mapPageStaticProps } from '@/utils/pageData'
import { getPromiseFromFetch } from '@/utils/request'

import { WPPageData } from '@/types'

export default function Home(
  pageData: InferGetStaticPropsType<typeof getStaticProps>
) {
  usePagePrecache(true, getPagePrecacheMedia(pageData))

  return <PageBuilder pageData={pageData} />
}

Home.getLayout = function getLayout(
  page: ReactElement,
  props: NextPageContext
) {
  return (
    <Layout pageData={props}>
      <Meta pageData={props} />
      {page}
    </Layout>
  )
}

export async function getStaticProps({
  locale,
  defaultLocale
}: GetStaticPropsContext) {
  const { data: pageData } = await getPromiseFromFetch<WPPageData>({
    method: 'get',
    url: `/${locale !== defaultLocale ? locale : ''}`
  })

  return {
    props: {
      ...(await mapPageStaticProps(pageData))
    }
  }
}
